import { HStack, Icon, Tooltip } from '@genial/components';
import { Box, Pressable } from 'native-base';
import React from 'react';

import {
  TableContent,
  TableContentItemColumn,
  TableContentItemText,
} from '../../../../../../../../../components/TableContent';
import { useGlobalAssetContext } from '../../../../../contexts';
import { usePrivatePensionAssetContext } from '../../../../../contexts/products/PrivatePension';
import { LateralBar } from '../../../components/LateralBar';
import { privatePensionConstants } from '../constants';
import { ListLoadingItemDesktop } from '../ListLoadingItem/desktop';

import { MinimumApplicationTooltip } from './components/MinimumApplicationTooltip';
import { MonthlyContributionTooltip } from './components/MonthlyContributionTooltip';

import { PrivatePensionItemTypes } from '.';

export const PrivatePensionItemDesktop: React.FC<PrivatePensionItemTypes.Props> = ({ offer }) => {
  const { setModalOpen, setOfferSelected } = usePrivatePensionAssetContext();
  const { infoGetter, selectedTab, accountId } = useGlobalAssetContext();

  const { Button, isSelected, forceLoading } = infoGetter(
    'privatePension',
    offer,
    'privatePensionId'
  );

  const onOpenDetailsModal = () => {
    if (!accountId) {
      return;
    }

    setModalOpen(true);
    setOfferSelected({ ...offer, accountId });
  };

  const getFlex = (index: number) => {
    const currentHead = privatePensionConstants.tableHead.find((_, i) => i === index);
    return currentHead?.flex || 1;
  };

  if (forceLoading) {
    return <ListLoadingItemDesktop />;
  }

  return (
    <TableContent
      direction="row"
      space={0}
      p={0}
      px="inline.xxxs"
      h="80px"
      isHighlighted={isSelected}>
      <LateralBar
        backgroundColor={selectedTab.color}
        borderTopLeftRadius="sm"
        borderBottomLeftRadius="sm"
      />
      <TableContentItemColumn flex={getFlex(0)}>
        <Tooltip testID="details-tooltip" label="Ver detalhes">
          <Pressable onPress={onOpenDetailsModal}>
            <Icon name="Info" size="xs" />
          </Pressable>
        </Tooltip>
      </TableContentItemColumn>
      <TableContentItemColumn flex={getFlex(1)}>
        <TableContentItemText>{offer.productNameNormalized}</TableContentItemText>
      </TableContentItemColumn>
      <TableContentItemColumn flex={getFlex(2)}>
        <TableContentItemText>{offer.productTypeNormalized}</TableContentItemText>
      </TableContentItemColumn>
      <TableContentItemColumn flex={getFlex(3)}>
        <TableContentItemText>{offer.monthlyRentabilityNormalized}</TableContentItemText>
      </TableContentItemColumn>
      <TableContentItemColumn flex={getFlex(4)}>
        <TableContentItemText>{offer.annualRentabilityNormalized}</TableContentItemText>
      </TableContentItemColumn>
      <TableContentItemColumn flex={getFlex(5)}>
        <TableContentItemText>{offer.twelveMonthsRentabilityNormalized}</TableContentItemText>
      </TableContentItemColumn>
      <TableContentItemColumn flex={getFlex(6)}>
        <HStack alignItems="center" space="stack.quarck">
          <MinimumApplicationTooltip
            minimumApplicationNormalized={offer.minimumApplicationNormalized}
            monthlyMinimumApplicationNormalized={offer.monthlyMinimumApplicationNormalized}
          />
          <TableContentItemText>{offer.minimumApplicationNormalized}</TableContentItemText>
        </HStack>
      </TableContentItemColumn>
      <TableContentItemColumn flex={getFlex(7)}>
        <HStack alignItems="center" space="stack.quarck">
          <MonthlyContributionTooltip
            minimumApplicationNormalized={offer.minimumApplicationNormalized}
            monthlyMinimumApplicationNormalized={offer.monthlyMinimumApplicationNormalized}
          />
          <TableContentItemText>{offer.monthlyMinimumApplicationNormalized}</TableContentItemText>
        </HStack>
      </TableContentItemColumn>
      <TableContentItemColumn flex={getFlex(8)}>
        <Box w="100%">
          <Button
            id={selectedTab.typeGetterId}
            offer={offer}
            productContextConstant={selectedTab}
          />
        </Box>
      </TableContentItemColumn>
    </TableContent>
  );
};
